import { ServerResponse } from 'http'

export interface SetCookieOptions {
  strict?: boolean
  maxAge?: number
  httpOnly?: boolean
}

const setCookie = (
  res: ServerResponse,
  key: string,
  value: string,
  options: SetCookieOptions | boolean = true
) => {
  const opts: SetCookieOptions =
    typeof options === 'boolean' ? { strict: options } : options

  const { strict = true, maxAge, httpOnly = false } = opts

  const sameSite = strict ? 'Strict' : 'None'
  const currentCookies = res.getHeader('Set-Cookie') || []

  const cookieParts = [`${key}=${value}`, 'Path=/', `SameSite=${sameSite}`]

  if (maxAge !== undefined) {
    cookieParts.push(`Max-Age=${maxAge}`)
  }

  if (httpOnly) {
    cookieParts.push('HttpOnly')
  }

  cookieParts.push('Secure')

  const newCookie = cookieParts.join('; ')

  const updatedCookies = Array.isArray(currentCookies)
    ? [...currentCookies, newCookie]
    : [currentCookies, newCookie]

  res.setHeader('Set-Cookie', updatedCookies as readonly string[])
}

export default setCookie
